import React from "react";
import { useQueries } from "react-query";

import QueryProgress from "@/components/common/QueryProgress";
import { useAreaApi } from "@/custom-hooks/apis/use-area-api";
import { useGenreApi } from "@/custom-hooks/apis/use-genre-api";
import { QueryKeys } from "@/global-state/react-query-keys";

type Props = {
  children: React.ReactNode;
};
const GlobalJotaiProvider: React.FC<Props> = (props) => {
  const { getAreaList } = useAreaApi();
  const { getGenreList } = useGenreApi();
  const results = useQueries([
    {
      queryKey: QueryKeys.getGenreList,
      queryFn: () => getGenreList(),
    },
    {
      queryKey: QueryKeys.getAreaList,
      queryFn: () => getAreaList(),
    },
  ]);
  if (results[0].isLoading || results[1].isLoading) return <QueryProgress />;
  if (results[0].error || results[1].error) return <h4>Error...</h4>;

  return <>{props.children}</>;
};

export default GlobalJotaiProvider;
